import { Component, Input } from '@angular/core';
import { UiOrganismMainTitleComponent } from '../ui-organism-main-title/ui-organism-main-title.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ui-organism-main-nav',
  standalone: true,
  imports: [UiOrganismMainTitleComponent, TranslatePipe],
  templateUrl: './ui-organism-main-nav.component.html',
  styleUrl: './ui-organism-main-nav.component.scss',
})
export class UiOrganismMainNavComponent {
  @Input() mainText: string = '';
}
